

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPython,       // Python
  faJsSquare,     // JavaScript
  faJava,         // Java
  faHtml5,        // HTML5
  faCss3Alt,      // CSS
  faGithub,       // GitHub
  faReact,        // React.js
  faNodeJs,       // Node.js
  faBootstrap,    // Bootstrap
  faPhp,          // PHP
  faDocker,       // Docker
} from '@fortawesome/free-brands-svg-icons';
import { 
  faDatabase, 
  faCogs, 
  faRobot, 
  faBrain, 
  faToolbox,      // for CAD
  faAtom,         // for MATLAB and scientific skills
  faPuzzlePiece,  // for Problem Solving
  faProjectDiagram,  // for 3D Models 
  faCode,
  faC,
  faCompassDrafting // Fixed the typo from aCompassDrafting to faCompassDrafting
} from '@fortawesome/free-solid-svg-icons';

// The component for displaying the skill icons in a responsive grid
const SkillIcons = () => {
  const skills1 = [
    { name: 'Python', icon: faPython },
    { name: 'C/C++', icon: faC },
    { name: 'SQL', icon: faDatabase },   // Placeholder icon for C/C++ tool-based
  ];
  
  const skills2 = [
    { name: 'Problem Solving', icon: faPuzzlePiece },
    { name: 'Mechanics', icon: faCogs },
    { name: '3D Models', icon: faProjectDiagram },
  ];
  
  const skills3 = [
    { name: 'Deep Learning', icon: faBrain },
    { name: 'Robotics', icon: faRobot },
    { name: 'Docker', icon: faDocker },

  ];
  

  

  return (
    <div style={styles.iconsMainContainer}>
      {[skills1, skills2, skills3,].map((skillSet, idx) => (
        <div style={styles.iconsContainer} key={idx}>
          {skillSet.map((skill) => (
            <div key={skill.name} style={styles.iconWrapper}>
              <FontAwesomeIcon icon={skill.icon} size="2x" />
              <p style={styles.iconLabel}>{skill.name}</p>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

const styles = {
  iconsMainContainer: {
    width: '90%',
    margin: '0 5%',
    display: 'flex',
    height: '30%',
    alignItems: 'center',
  },
  iconsContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  iconWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: 'transparent',
    color: 'white',
  },
  iconLabel: {
    marginTop: '3px',
    fontSize: '10px',
    color: '#f1fa8c', // Yellow for icon labels
  },
};

export default SkillIcons;